import { render, staticRenderFns } from "./CustomerBespokePriceList.vue?vue&type=template&id=21105131&scoped=true&"
import script from "./CustomerBespokePriceList.vue?vue&type=script&lang=js&"
export * from "./CustomerBespokePriceList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBespokePriceList.vue?vue&type=style&index=0&id=21105131&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21105131",
  null
  
)

export default component.exports